import { render, staticRenderFns } from "./flvh265-4.vue?vue&type=template&id=496ad05f&scoped=true&"
import script from "./flvh265-4.vue?vue&type=script&lang=js&"
export * from "./flvh265-4.vue?vue&type=script&lang=js&"
import style0 from "./flvh265-4.vue?vue&type=style&index=0&id=496ad05f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ad05f",
  null
  
)

export default component.exports